import { render, staticRenderFns } from "./ForceGauge.vue?vue&type=template&id=0ef70850&scoped=true&"
import script from "./ForceGauge.vue?vue&type=script&lang=js&"
export * from "./ForceGauge.vue?vue&type=script&lang=js&"
import style0 from "./ForceGauge.vue?vue&type=style&index=0&id=0ef70850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef70850",
  null
  
)

export default component.exports